import {
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material'
import type { FormikProps } from 'formik'
import { type ChangeEvent, type FC, useId } from 'react'
import FormikErrorMessage from 'src/components/formikErrorMessage/FormikErrorMessage'
import type { FormulaRuleProps } from './EditResponseFormulaRuleDrawer'

export const MAX_FORMULA_FRACTIONAL_DIGITS = 10

const FractionalDigitsRow: FC<{
  formikProps: FormikProps<FormulaRuleProps>
}> = ({
  formikProps: {
    values: { decimalPoint },
    setFieldValue,
    errors,
    touched,
  },
}) => {
  const onToggle = (_: ChangeEvent<HTMLInputElement>, checked: boolean) =>
    setFieldValue('decimalPoint.isActive', checked ? 1 : 0)

  const onChangeDigits = (e: ChangeEvent<HTMLInputElement>) =>
    setFieldValue(
      'decimalPoint.value',
      e.target.value === '' ? undefined : Number(e.target.value),
    )

  const decimalPointInputId = useId()

  return (
    <Stack>
      <FormControlLabel
        control={
          <Switch checked={!!decimalPoint?.isActive} onChange={onToggle} />
        }
        label="小数点以下の桁数を設定する"
        sx={{ mb: 1 }}
      />
      <Stack>
        <Stack direction="row" alignItems="center" sx={{ mb: 1 }} spacing={1}>
          <TextField
            id={decimalPointInputId}
            type="number"
            size="small"
            name="decimalPoint"
            placeholder="1"
            slotProps={{ htmlInput: { min: 0 } }}
            value={decimalPoint?.value ?? ''}
            onChange={onChangeDigits}
            disabled={!decimalPoint?.isActive}
            sx={{ width: 60 }}
          />
          <label htmlFor={decimalPointInputId}>桁</label>
        </Stack>
        <Typography variant="caption">
          ※この設定をオフにすると、小数点以下第三位で四捨五入されます
        </Typography>
      </Stack>
      <FormikErrorMessage
        name="decimalPoint"
        errors={errors}
        touched={touched}
      />
    </Stack>
  )
}

export default FractionalDigitsRow
